/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkWhois } from "../../funcs/networkGetNetworkWhois.js";
import { GetNetworkWhoisRequest$zodSchema } from "../../models/getnetworkwhoisop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkWhoisRequest$zodSchema,
};

export const tool$networkGetNetworkWhois: ToolDefinition<typeof args> = {
  name: "network-get-network-whois",
  description: `查询域名的WHOIS注册信息

想知道一个域名是什么时候注册的、注册商是谁、什么时候到期？WHOIS信息可以告诉你这一切。

## 功能概述
这是一个在线的WHOIS查询工具。你可以通过如下两种方式获取WHOIS信息：

- **默认行为**（不带参数）：\`GET /api/v1/network/whois?domain=google.com\`
  - 返回一个JSON对象，\`whois\` 字段为原始、未处理的WHOIS文本字符串。
- **JSON格式化**：\`GET /api/v1/network/whois?domain=google.com&format=json\`
  - 返回一个JSON对象，\`whois\` 字段为解析后的JSON对象，包含WHOIS信息中的键值对。

这样你既可以获得最全的原始信息，也可以方便地处理结构化数据。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkWhois(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
